import { __awaiter } from "tslib";
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ReducerType } from './types';
const initialState = {
    orderFulfillment: null,
    loading: 'idle',
    error: null
};
export var OrderFulfillmentActionType;
(function (OrderFulfillmentActionType) {
    OrderFulfillmentActionType["FetchOrderFulfillment"] = "orderFulfillment/fetchOrderFulfillment";
    OrderFulfillmentActionType["UpdateOrderFulfillment"] = "orderFulfillment/updateOrderFulfillment";
})(OrderFulfillmentActionType || (OrderFulfillmentActionType = {}));
export const fetchOrderFulfillment = createAsyncThunk(OrderFulfillmentActionType.FetchOrderFulfillment, (orderId, { getState, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    const { api } = getState().config;
    if (!api)
        return;
    try {
        const response = yield api.getOrderFulfillment(orderId);
        return response;
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const updateOrderFulfillment = createAsyncThunk(OrderFulfillmentActionType.UpdateOrderFulfillment, ({ orderId, data }, { getState, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    const { api } = getState().config;
    if (!api)
        return;
    try {
        return yield api.putOrderFulfillment(orderId, data);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
const orderFulfillmentSlice = createSlice({
    name: ReducerType.OrderFulfillment,
    initialState,
    reducers: {
        resetOrderFulfillment: () => initialState
    },
    extraReducers: builder => {
        builder
            .addCase(fetchOrderFulfillment.fulfilled, (state, action) => {
            state.orderFulfillment = action.payload;
            state.loading = 'idle';
            state.error = null;
        })
            .addCase(fetchOrderFulfillment.pending, state => {
            state.loading = 'pending';
        })
            .addCase(fetchOrderFulfillment.rejected, (state, action) => {
            state.error = action.payload;
            state.loading = 'idle';
        })
            .addCase(updateOrderFulfillment.fulfilled, (state, action) => {
            state.orderFulfillment = action.payload;
            state.loading = 'idle';
            state.error = null;
        })
            .addCase(updateOrderFulfillment.pending, state => {
            state.loading = 'pending';
        })
            .addCase(updateOrderFulfillment.rejected, (state, action) => {
            state.error = action.payload;
            state.loading = 'idle';
        });
    }
});
export const { resetOrderFulfillment } = orderFulfillmentSlice.actions;
export const selectOrderFulfillment = (state) => state.orderFulfillment;
export const orderFulfillmentReducer = orderFulfillmentSlice.reducer;
